export default "__VITE_ASSET__KADMXAz0__"